import { render, staticRenderFns } from "./SideBySide.vue?vue&type=template&id=6e4990d0&"
import script from "./SideBySide.vue?vue&type=script&lang=js&"
export * from "./SideBySide.vue?vue&type=script&lang=js&"
import style0 from "./SideBySide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports